import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import Block from 'shopper/components/Block';
import Button from 'shopper/components/Button';
import Flex from 'shopper/components/Flex';
import Icon from 'shopper/components/Icon';

import Image from 'components/Image';

import { getAdCssBackgroundColorProp } from 'lib/ads';
import { setLocalStorage } from 'lib/localStorage';

import { useTopbar } from 'providers/TopbarProvider';

import APP from 'constants/app';
import LOCAL_STORAGE from 'constants/localStorage';
import Z_INDEX_SCALE from 'constants/zIndexScale';

const SCROLL_THRESHOLD_TO_PULL_UP_BANNER = 50;

const toMobileImageWithHigherRes = (mobileImage) =>
  `https://i.promobit.com.br/ar/720/${mobileImage.split('/')[3]}`;

const TopbarAd = ({ onClose }) => {
  const {
    topbarAd: { bgcolor, description, isClosable, image, mobileImage, url },
    setTopbarAd,
  } = useTopbar();
  const [isScrollPositionAtThreshold, setScrollPositionAtThreshold] =
    useState(true);

  const onCloseButtonClick = (e) => {
    e.preventDefault();
    setLocalStorage(LOCAL_STORAGE.IS_EXTENSION_ACTIVE, 'true');
    setTopbarAd(null);
    onClose(e);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY < SCROLL_THRESHOLD_TO_PULL_UP_BANNER) {
        setScrollPositionAtThreshold(true);
        return;
      }

      if (
        window.scrollY > SCROLL_THRESHOLD_TO_PULL_UP_BANNER &&
        isScrollPositionAtThreshold
      ) {
        setScrollPositionAtThreshold(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <Block
        style={{ background: getAdCssBackgroundColorProp(bgcolor) }}
        height={['4rem', null, '2.5rem']}
        display={mobileImage ? 'block' : ['none', null, null, 'block']}
        full
      >
        <Flex
          as="a"
          alignItems="center"
          justifyContent="center"
          mx="auto"
          position="fixed"
          top={[!isScrollPositionAtThreshold ? '-10px' : 0, null, 0]}
          target="_blank"
          rel="noopener"
          zIndex={Z_INDEX_SCALE.SIZE_4}
          href={url}
          maxWidth={isClosable ? '64rem' : '100%'}
          full
        >
          <Image
            sizes={
              mobileImage
                ? '(max-width: 768px) 0px, 1920px'
                : '(max-width: 1024px) 1px, 1920px'
            }
            loading={null}
            alt={description}
            src={image}
            srcSet={
              mobileImage
                ? `${toMobileImageWithHigherRes(
                    mobileImage
                  )} 428w, ${image} 1920w`
                : `${APP.LOCAL_IMAGE_PATH}/general/placeholder.jpg 1w, ${image} 1920w`
            }
            height={['58px', null, '2.5rem']}
            width={['100%', null, 1400, 1920]}
            priority
          />
          {isClosable && (
            <Button
              type="ghost"
              size="size4"
              position="absolute"
              icon={<Icon name="close" />}
              right={0}
              onClick={onCloseButtonClick}
            />
          )}
        </Flex>
      </Block>
    </>
  );
};

TopbarAd.defaultProps = {
  onClose: () => {},
};

TopbarAd.propTypes = {
  onClose: PropTypes.func,
};

export default TopbarAd;
